type Listener = (loading: boolean) => void;

class LanguageManager {
  private listeners = new Set<Listener>();

  private isLoading = false;

  private pendingRequests = 0;

  private languageChanging = false;

  private hideTimer: ReturnType<typeof setTimeout> | null = null;

  subscribe(listener: Listener) {
    this.listeners.add(listener);

    listener(this.isLoading);

    return () => {
      this.listeners.delete(listener);
    };
  }

  private notify() {
    this.listeners.forEach((listener) => listener(this.isLoading));
  }

  startLanguageChange() {
    this.languageChanging = true;
    this.isLoading = true;
    this.pendingRequests = 0;

    this.notify();

    // Fallback: if no API request starts within 500ms,
    // hide the loader automatically.
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
    }

    this.hideTimer = setTimeout(() => {
      if (this.pendingRequests === 0) {
        this.finishLanguageChange();
      }
    }, 500);
  }

  requestStarted() {
    if (!this.languageChanging) return;

    this.pendingRequests++;
  }

  requestFinished() {
    if (!this.languageChanging) return;

    this.pendingRequests--;

    if (this.pendingRequests <= 0) {
      this.finishLanguageChange();
    }
  }

  private finishLanguageChange() {
    this.pendingRequests = 0;
    this.languageChanging = false;

    if (this.hideTimer) {
        clearTimeout(this.hideTimer);
        this.hideTimer = null;
    }

    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            this.isLoading = false;
            this.notify();
        });
    });
}

  getLoadingState() {
    return this.isLoading;
  }
}

export const languageManager = new LanguageManager();